export default __webpack_public_path__ + "static/media/consultPattern.75e82a41.svg";